import { memo, NamedExoticComponent, ReactNode } from 'react';
import cn from 'classnames';

import styles from './styles.module.css';

type SidebarButtonProps = {
  onClick: () => void;
  collapsed?: boolean;
  title: ReactNode;
  icon: ReactNode;
  groupItem?: boolean;
};

const SidebarButton: NamedExoticComponent<SidebarButtonProps> = memo(
  ({ onClick, collapsed = false, title, icon, groupItem }) => (
    <button
      type="button"
      className={cn(styles.sidebarButton, {
        [styles.sidebarButtonCollapsed]: collapsed,
        [styles.sidebarButtonGroup]: groupItem,
      })}
      onClick={onClick}
    >
      {icon}
      {!collapsed && title}
    </button>
  ),
);

export default SidebarButton;
